import { useRetrieveAvailableSlotsQuery } from "@/react/features/smp/licenses/licensesApi";
import {
  PACKAGE_TYPES,
  PACKAGES,
} from "@/react/features/smp/licenses/constants";
import { useSelector } from "react-redux";
import { customerIdSelector } from "@/react/features/customer/customerSlice";
import { useEffect } from "react";

export const useAvailableLicenseForTrunks = () => {
  const customerId = useSelector(customerIdSelector);
  const {
    data: licenseExists,
    isLoading: licenseLoading,
    refetch,
  } = useRetrieveAvailableSlotsQuery({
    opts: { packageId: [PACKAGES[PACKAGE_TYPES.TRUNKS]] },
  });
  useEffect(() => {
    refetch && refetch();
  }, [customerId]);
  return { licenseExists, licenseLoading };
};
